







































import Vue from 'vue'
import Component from 'vue-class-component';
import { DxSelectBox } from 'devextreme-vue';
import { DxButton } from 'devextreme-vue';
import { PageTitle } from '@questelservices/common-vue';
import { SelectOption } from '../models/SelectOption';
import { ClientService } from '../service/ClientService';
import ClientSetupForm from '../components/client/client-setup-form.vue';
import CreateClientForm from '../components/client/create-client.form.vue';

@Component({
  components: {    
    PageTitle,
    DxSelectBox,
    DxButton,
    ClientSetupForm,
    CreateClientForm
  }
})
export default class ClientSetup extends Vue {
  clients: Array<SelectOption> = [];
  selectedClient: Guid = '';
  showClientSetup: boolean = false
  showCreateClient: boolean = false;


  clientService: ClientService = new ClientService();

  get selectedClientOption() {
    return this.clients.filter(c => c.value == this.selectedClient)[0];
  }

  constructor() {
    super();    
  }

  mounted() {
    this.loadData();
  }

  async loadData() {
    let clients = await this.clientService.getAll();
    this.clients = clients.map(c => {
      return { text: c.ClientName, value: c.ClientId };
    });
  }

  openClientSetup() {
    this.showClientSetup = true;
  }

  hidingClientSetup() {
    this.showClientSetup = false;
  }

  openCreateClient() {
    this.showCreateClient = true;
  }

  async hidingCreateClient() {
    this.showCreateClient = false;
    await this.loadData();
  }
}
